var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',{attrs:{"click-action":_vm.$emit('click'),"title":_vm.$t('general.delete'),"disabled":_vm.disabled}},[_vm._v("X")])
}
var staticRenderFns = []

export { render, staticRenderFns }